export const Triangle = ({ width = 10, height = 8 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 0L10 8L0 8L5 0Z" fill="currentColor" />
        </svg>
    );
};
